export enum ERideEventName {
  RIDE_TRANSITION_SELECTED = 'Ride Transition Selected',
  RIDE_ENTRY_POINT_VIEWED = 'Ride Entry Point Viewed',
}

/** Shared by click and impression events, so clicks / impressions is a per-surface CTR */
export enum ERideTransitionPlacement {
  HERO_CARD = 'hero_card',
  /** Desktop global header only — the mobile web tab rows report their own values */
  GLOBAL_HEADER_TAB = 'global_header_tab',
  HOME_HERO_TABS = 'home_hero_tabs',
  RV_DELIVERY_HERO_TABS = 'rv_delivery_hero_tabs',
  FOOTER = 'footer',
  RECOMMENDATIONS_TILE = 'recommendations_tile',
  RECOMMENDATIONS_VIEW_ALL = 'recommendations_view_all',
  RECOMMENDATIONS_LOCATION_LINK = 'recommendations_location_link',
  TRIP_STATIONARY_BANNER_CTA = 'trip_stationary_banner_cta',
  TRIP_STATIONARY_BANNER_TILE = 'trip_stationary_banner_tile',
  /** Extra tile inserted at grid position 12 on a healthy-supply RV search. */
  SRP_RIDE_CROSS_SELL_POSITION_12 = 'srp_ride_cross_sell_position_12',
}

export interface IRideTransitionSelectedEvent {
  placement: ERideTransitionPlacement;
  destinationUrl: string;
  /** Present when the transition targets a specific ride.auto listing */
  rentalID?: number;
}

/** An entry point was on screen — the denominator for Ride Transition Selected */
export type TRideEntryPointViewedEvent = Pick<
  IRideTransitionSelectedEvent,
  'placement' | 'destinationUrl'
>;
